<template>
  <v-card>
    <v-card-title
      class="text-center d-block pb-0 pr-4 d-flex justify-space-between"
    >
      Valitse media

      <v-btn
        icon
        @click="closeDialog"
      >
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-divider
      class="mt-2 mb-4"
    />

    <v-card-text>
      <v-card
        v-for="(medium, i) in media"
        :key="i"
        tile
        dark
        elevation="1"
        class="text-center"
        :class="{
           'mb-4': i < media.length - 1,
        }"
        :style="{
          backgroundColor: medium.bgColor,
          border: `0px solid ${medium.borderColor}`,
        }"
        @click="() => submit(medium.value)"
      >
        <v-card-title
          class="d-block subtitle-1 font-weight-bold text-uppercase pb-0"
          :style="{
            color: medium.textColor,
          }"
        >
          {{ medium.title }}
        </v-card-title>

        <div
          class="d-flex justify-center align-center pt-1 pb-2"
        >
          <v-icon
            :color="medium.textColor"
          >
            {{ medium.icon }}
          </v-icon>
        </div>

        <v-card-text
          class="pt-0"
          :style="{
            color: medium.textColor,
          }"
        >
          {{ medium.subtitle }}
        </v-card-text>
      </v-card>
    </v-card-text>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>Miten tämä toimii?</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            class="caption"
          >
            <p>
              Vaihtoehdoista aukeaa laitteesi oma kamera. Ottamasi kuva tai video aukeaa
              Vilkkeeseen, jossa voit vielä muokata ja vahvistaa lähetyksen. Mitään mediaa
              ei ladata palvelimelle ennen kuin olet itse vahvistanut sen Vilkkeessä.
            </p>

            <b>Kuvat</b>

            <p>
              Kuvat pienennetään ja pakataan automaattisesti enintään 1000x1000-kokoisiksi,
              jotta kuvat latautuvat nopeasti.
            </p>

            <b>Videot</b>

            <p>
              Yli 7 sekunnin videot lyhennetään automaattisesti 7 sekunnin mittaiseksi.
              Vilkkeellä ei ole suoraa yhteyttä laitteesi kameraan, joten kamerasi
              esikatselussa videon pituus voi olla teoriassa mitä tahansa. Vilkkeen
              esikatselussa video rajautuu kuitenkin enintään 7 sekuntiin.
              Videot pakataan HD-formaattiin (720p), jotta ne latautuvat nopeasti.
            </p>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      dialogProps: 'dialog/dialogProps',
    }),

    onSubmit() {
      return this.dialogProps.onSubmit;
    },
  },

  data: () => ({
    media: [
      {
        title: 'Ota kuva',
        subtitle: 'Voit muokata kuvaa ennen lähetystä.',
        value: 'image',
        icon: 'camera_alt',
        textColor: '#2979FF',
        borderColor: 'rgba(41, 121, 255, 0.25)',
        bgColor: 'rgb(41, 121, 255, 0.15)',
      },
      {
        title: 'Nauhoita video (beta)',
        subtitle: 'Videot ovat enintään 7 sekuntia pitkiä.',
        value: 'video',
        icon: 'videocam',
        textColor: '#F50057',
        borderColor: 'rgba(245, 0, 87, 0.25)',
        bgColor: 'rgb(245, 0, 87, 0.15)',
      },
    ],
  }),

  methods: {
    ...mapActions({
      closeDialog: 'dialog/closeDialog',
    }),

    submit(selectedMedium) {
      this.onSubmit(selectedMedium);
      this.closeDialog();
    },
  },
};
</script>
